import { render, staticRenderFns } from "./IntegrationTypes.vue?vue&type=template&id=49a81f25&"
import script from "./IntegrationTypes.vue?vue&type=script&lang=js&"
export * from "./IntegrationTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports